import React, { Component } from 'react';

export default class NotFound extends Component {
  render() {
    return (
      <div className="NotFound">
        Page not found!
      </div>
    )
  }
}